import { TourActions } from 'aria-viewer/tour'
import { TOUR_DRAWER, MAP_DRAWER, STOP_LIST_DRAWER, HIDE_DRAWER } from 'aria-viewer/drawer/drawerMenuActions'
import { ANALYTICS_REGISTRATION_CLOSED } from 'aria-viewer/analytics/analyticActions'
import ModalActions from 'aria-viewer/modal/modalActions'
import { OPEN_PAYMENTS_MODAL, CLOSE_PAYMENTS_MODAL, PAYMENT_MOUSE_EXITED } from 'aria-viewer/payments/paymentActions'
import { CommonActionTypes } from 'aria-viewer/interactive-element/constants'

import 'rxjs/add/operator/delay'
import 'rxjs/add/operator/take'
import 'rxjs/add/operator/takeUntil'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/skipWhile'

/**
 * Commone Epic Functions...
 */

export const tourLoadedBatch = action =>
    batchContainsType(action, TourActions.LOADING) && action.payload.some(element => element.value.tour == false)

export const tourLoaded = action =>
    tourLoadedBatch(action) || (action.type == TourActions.LOADING && action.value.tour == false)

export const isReduxBatch = action => action.type == '@@redux-batch-middleware/BATCH'

export const batchContainsType = (action, type) =>
    isReduxBatch(action) && action.payload.some(element => element.type == type)

export const isActionType = (action, type) => action.type == type || batchContainsType(action, type)

export const registrationModalClosed = action => action.type == ANALYTICS_REGISTRATION_CLOSED

export const isModalOpen = action =>
    isReduxBatch(action)
        ? action.payload.some(element => element.type == ModalActions.OPEN_MODAL)
        : [
              TOUR_DRAWER,
              MAP_DRAWER,
              STOP_LIST_DRAWER,
              OPEN_PAYMENTS_MODAL,
              CommonActionTypes.OPEN_MODAL,
              ModalActions.OPEN_MODAL,
          ].includes(action.type)

export const isModalClosed = action =>
    isReduxBatch(action)
        ? action.payload.some(element =>
              [ModalActions.CLOSE_MODAL, ModalActions.CLOSE_ALL_MODALS, PAYMENT_MOUSE_EXITED].includes(element.type)
          )
        : [
              ModalActions.CLOSE_ALL_MODALS,
              CommonActionTypes.CLOSE_MODAL,
              CLOSE_PAYMENTS_MODAL,
              HIDE_DRAWER,
              ModalActions.CLOSE_MODAL,
              ANALYTICS_REGISTRATION_CLOSED,
          ].includes(action.type)
/**
 * Observe First Scene Entered
 *
 * The logic is designed to trigger 1 once after initial scene is entered, considers location drawer, intros, etc..
 *
 * @param  action$
 * @param  store
 * @param  delay time to wait
 * @return observerable
 */
export const observeFirstSceneEntered = (action$, store, delay) => {
    return (
        action$
            .filter(
                action =>
                    // If First stop is loaded without an intro video
                    (isActionType(action, TourActions.STOP_CHANGED) &&
                        //and we are not presenting an Intro Video
                        action.current &&
                        (action.current.intro_media == null || action.current.intro_media == 0)) ||
                    // or if there is an intro and its dismissed
                    isActionType(action, TourActions.SET_IS_STOP_INTRO_PLAYED) ||
                    // or if we skipped this due to TOUR_DRAWER AND it is dimissed.
                    isActionType(action, HIDE_DRAWER) ||
                    // or they closed the registration (on mobile..)
                    registrationModalClosed(action)
            )
            .delay(delay) // wait n seconds,
            // While location drawer is present lets not do anything, this skips this attemp
            .skipWhile(_ => {
                const state = store.getState()
                if (state.getIn(['drawerMenu', 'name']) == TOUR_DRAWER) return true

                //on mobile we want to wait till after modals are gone..
                if (state.getIn(['drawerMenu', 'name']) == TOUR_DRAWER) return true

                //ensure we are not blocked by intro video
                let stopList = state.getIn(['tour', 'stops', 'list'])
                let stopId = state.getIn(['tour', 'stops', 'current'])
                if (stopList && stopList[stopId] && stopList[stopId].intro_media > 0) return true
                return false
            })
            //Only the first time
            .take(1)
    )
}
